// Accessor de store pour le code hors-composant (ex. defaultObjects).
// On NE lit PAS store.getState() à la création d'un objet (interdit pendant un
// dispatch — getBaseLocation est appelé dans des reducers). À la place, on cache
// la tarification du Master via store.subscribe (callback exécuté APRÈS chaque
// dispatch).
let _store = null
let _masterTva = 0
let _masterTarifJournalier = 0

const num = (v) => {
	const n = parseFloat(v)
	return isNaN(n) ? 0 : n
}

const extractTarification = (state) => {
	try {
		let ed =
			state &&
			state.masterReducer &&
			state.masterReducer.masterEntite &&
			state.masterReducer.masterEntite.extra_data
		if (typeof ed === "string") ed = JSON.parse(ed || "{}")
		return (ed && ed.tarification) || {}
	} catch (e) {
		return {}
	}
}

export const setStore = (store) => {
	_store = store
	const refresh = () => {
		const t = extractTarification(store.getState())
		_masterTva = num(t.generale && t.generale.tva)
		_masterTarifJournalier = num(t.location && t.location.tarifJournalier)
	}
	store.subscribe(refresh)
	refresh()
}

export const getStore = () => _store

// Valeurs de tarif du Master, lues depuis un cache — jamais via getState()
// pendant un dispatch. Renvoient 0 tant que le Master n'est pas chargé.
export const getMasterTva = () => _masterTva
export const getMasterTarifJournalier = () => _masterTarifJournalier
